import { EditOutlined, FolderOpenFilled } from '@ant-design/icons';
import { Button, Card, Col, Row, Typography } from 'antd';
import React from 'react';

import { usePermission } from '@/hooks/usePermission';
import { FolderItemResponse } from '@/proxy';

export type FolderListProps = {
  folders: FolderItemResponse[];
  onFolderOpen: (path: string) => void;
  onOpenRenameFolderModal: (path: string, name: string) => void;
};

export function FolderList({
  folders,
  onFolderOpen,
  onOpenRenameFolderModal,
}: FolderListProps): React.JSX.Element {
  const onRenameFolder = (e: React.MouseEvent<HTMLSpanElement>, path: string, name: string) => {
    e.stopPropagation();
    onOpenRenameFolderModal(path, name);
  };

  const { isMAAdmin } = usePermission();

  return (
    <Row gutter={[16, 16]}>
      {folders.map((folder) => (
        <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={6} key={folder.name}>
          <Card
            hoverable
            onClick={() => onFolderOpen(folder.path)}
            style={{
              borderColor: '#e6e6e6',
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
            }}
            styles={{
              body: {
                padding: '16px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
              },
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: 1 }}>
              <FolderOpenFilled style={{ fontSize: 24 }} />
              <Typography.Text
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  minWidth: 0,
                  flex: 1,
                }}
              >
                {folder.name}
              </Typography.Text>
            </div>
            {isMAAdmin && (
              <div style={{ display: 'flex', gap: 4 }}>
                <Button
                  type='text'
                  icon={<EditOutlined />}
                  onClick={(e) => onRenameFolder(e, folder.path, folder.name)}
                />
              </div>
            )}
          </Card>
        </Col>
      ))}
    </Row>
  );
}
